module.exports = __webpack_public_path__ + "static/media/magnus2.7638449f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/Characters/magnus2.jpg
// module id = 204
// module chunks = 0